/**
 * @file usePasswordPolicy.ts
 *
 * @fileoverview Hook to read password policy configuration from the backend.
 */
import { PASSWORD_MIN_LENGTH } from '~/vcl/atoms/01-forms/03-input/02-password-feedback';
import { useConfig } from '~/jobiqo/context/config';

interface PasswordPolicy {
  minLength: number;
}

/**
 * Returns password policy settings from backend config (getAppConfig).
 * Falls back to the default PASSWORD_MIN_LENGTH constant if config is not available.
 */
export function usePasswordPolicy(): PasswordPolicy {
  const { getConfigByName } = useConfig();
  const config = getConfigByName('policy_constraints.0.character_length');

  const rawValue = config?.value?.[0];
  const minLength =
    typeof rawValue === 'string' && rawValue !== ''
      ? parseInt(rawValue, 10)
      : PASSWORD_MIN_LENGTH;

  return { minLength: isNaN(minLength) ? PASSWORD_MIN_LENGTH : minLength };
}
